import React, {Component} from "react";
import DataGrid, {
    Column,
    Export,
    GroupPanel
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import ExcelJS from "exceljs";
import saveAs from "file-saver";


class TestTable extends Component {
    constructor(props) {
        super(props);
        this.employees = props.productList;

        this.state = {
            excelFilterEnabled: true
        };
    }

    handleExportClick = e => {
        this.excelExport(this.state.instanceDataGrid);
    };

    excelExport = DataGrid => {
        let ExcelJSWorkbook = new ExcelJS.Workbook();
        let worksheet = ExcelJSWorkbook.addWorksheet("Информация по всем пользователям");
        let columns = DataGrid.getVisibleColumns();
        let headerRow = worksheet.addRow();
        for (let i = 0; i < columns.length; i++) {
            let currentColumnWidth = DataGrid.option().columns[i].width;
            worksheet.getColumn(i + 1).width =
                currentColumnWidth !== undefined ? currentColumnWidth / 6 : 20;
            let cell = headerRow.getCell(i + 1);
            cell.value = columns[i].caption;
        }

        // eslint-disable-next-line no-unused-expressions
        this.state.excelFilterEnabled === true
            ? (worksheet.views = [{state: "frozen", ySplit: 1}])
            : undefined;

        worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false
        };


        DataGrid.getController("data")
            .loadAll()
            .then(function (allItems) {

                for (let i = 0; i < allItems.length; i++) {

                    let dataRow = worksheet.addRow();
                    if (allItems[i].rowType === "data") {
                        dataRow.outlineLevel = 1;
                    }
                    for (let j = 0; j < allItems[i].values.length; j++) {
                        let cell = dataRow.getCell(j + 1);
                        cell.value = allItems[i].values[j];
                    }
                }






                ExcelJSWorkbook.xlsx.writeBuffer().then(function (buffer) {
                    saveAs(
                        new Blob([buffer], {type: "application/octet-stream"}),
                        `${DataGrid.option().export.fileName}.xlsx`
                    );
                });
            });
    };

    render() {

        let Width = window.innerWidth

        return (
            <div>
                <DataGrid
                    style={{display: "none"}}
                    id={"gridContainer"}
                    dataSource={this.employees}
                    showBorders={true}
                    showColumnHeaders={true}
                    onCellPrepared={this.onCellPrepared}
                    onContentReady={this.onContentReady}
                >

                    <Column dataField={"email"} caption={"Логин"} width={200}/>
                    <Column dataField={"name"} caption={"Имя"} width={200}/>
                    <Column dataField={"post"} caption={"Должность"} width={150}/>
                    <Column dataField={"type"} caption={"Тип"} width={150}/>
                    <Column dataField={"client"} caption={"Клиент"} width={200}/>
                    <Column dataField={"active"} caption={"Статус"} width={150}/>
                    <Column dataField={"updatedAt"} caption={"Дата последнего изменения"} width={220}/>
                    <Column dataField={"dateConfirmPersonalData"} caption={"Согласие на обработку персональных данных"} width={250}/>

                    <Export
                        enabled={true}
                        fileName="Информация о пользователях"
                        excelFilterEnabled={true}
                        customizeExcelCell={this.customizeExcelCell}
                    />
                    <GroupPanel visible={true}/>
                </DataGrid>
                <div>
                   <div style={{cursor: "pointer"}}>
                        <div style={Width > 1024 ? {display: "flex"} : {display: "block"}}>
                            <span>
                            <Button style={{
                                color: "blue",
                                textDecoration: "underline"
                            }}
                                    text="Скачать отчет"
                                    type="danger"
                                    onClick={this.handleExportClick}/>
                        </span>
                        </div>
                    </div>


                </div>
            </div>
        );
    }

    onContentReady = e => {
        let instanceGrid = e.component.instance();

        this.setState({
            excelFilterEnabled: instanceGrid.option().export.excelFilterEnabled,
            instanceDataGrid: instanceGrid
        });
    };

    onCellPrepared(e) {
        if (e.rowType === "data") {
            if (e.data.OrderDate < new Date(2014, 2, 3)) {
                e.cellElement.classList.add("oldOrder");
            }
            if (e.data.SaleAmount > 15000) {
                if (e.column.dataField === "Employee") {
                    e.cellElement.classList.add("highAmountOrder_employee");
                }
                if (e.column.dataField === "SaleAmount") {
                    e.cellElement.classList.add("highAmountOrder_saleAmount");
                }
            }
        }
    }

    customizeExcelCell(options) {
        if (options.gridCell.rowType === "data") {
            if (options.gridCell.data.SaleAmount > 15000) {
                if (options.gridCell.column.dataField === "Employee") {
                    options.font.bold = true;
                }
                if (options.gridCell.column.dataField === "SaleAmount") {
                    options.backgroundColor = "#FFBB00";
                    options.font.color = "#000000";
                }
            }
        }
    }
}

export default TestTable;
